import { Link } from "react-router-dom";
import { HaevnLogo } from "./Navigation";
import { fontSans, fontMono, color as T } from "../design/tokens";

// Footer — Phase 1 visual system.
//
// Editorial. Ink-navy foundation. Mono uppercase column headers.
// Hairline dividers. No decorative gradients or shadows. The link set
// is intentionally lighter than before — over-crowded footers were
// costing legibility. Every retained link still resolves; nothing was
// deleted from the routing table.
const primary = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/membership", label: "Membership" },
  { to: "/blog", label: "Journal" },
  { to: "/about", label: "About" },
];

const company = [
  { to: "/careers", label: "Careers" },
  { to: "/press", label: "Press" },
  { to: "/perspective", label: "Perspective" },
  { to: "/verification", label: "Verification" },
];

const legal = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
];

const socials = [
  {
    href: "https://www.instagram.com/haevnapp/#",
    label: "Instagram",
    testid: "footer-instagram",
    svg: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>,
  },
  {
    href: "https://www.threads.com/@haevnapp",
    label: "Threads",
    testid: "footer-threads",
    svg: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L5.617 6.976c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.32.145 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.161 2.65l-.005-.001zm1.994-14.406c-.276 0-.557.009-.842.026-1.596.093-2.593.827-2.538 1.865.058 1.088 1.258 1.594 2.418 1.532 1.066-.057 2.462-.475 2.696-3.246-.577-.11-1.164-.177-1.734-.177Z"/></svg>,
  },
  {
    href: "https://www.facebook.com/HAEVNAPP",
    label: "Facebook",
    testid: "footer-facebook",
    svg: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>,
  },
  {
    href: "https://www.tiktok.com/@haevnapp",
    label: "TikTok",
    testid: "footer-tiktok",
    svg: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/></svg>,
  },
  {
    href: "https://www.youtube.com/@haevntalks",
    label: "YouTube",
    testid: "footer-youtube",
    svg: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19.1c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/></svg>,
  },
  {
    href: "https://www.reddit.com/r/HAEVNAPP/",
    label: "Reddit",
    testid: "footer-reddit",
    svg: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.688-.085-.084-.085-.221 0-.305.084-.084.222-.084.307 0 .379.377 1.008.561 1.924.561l.008.002.008-.002c.915 0 1.544-.184 1.924-.561.085-.084.223-.084.307 0zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918zm4.34-.919c-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918 0-.507-.414-.919-.922-.919zM12 2C6.478 2 2 6.477 2 12c0 5.522 4.478 10 10 10 5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10zm5.655 11.405c.012.136.018.273.018.411 0 2.095-2.44 3.795-5.45 3.795-3.01 0-5.45-1.7-5.45-3.795 0-.138.006-.275.018-.411a1.413 1.413 0 0 1-.567-1.136c0-.782.636-1.416 1.42-1.416.378 0 .722.15.972.394a7.262 7.262 0 0 1 3.46-.916l.663-3.113.021-.064a.216.216 0 0 1 .258-.155l2.21.492a1.003 1.003 0 0 1 .907-.577c.556 0 1.006.448 1.006 1.002 0 .553-.45 1.002-1.006 1.002-.553 0-1-.447-1.004-.998l-1.963-.437-.593 2.788a7.225 7.225 0 0 1 3.395.908c.25-.242.593-.39.967-.39.784 0 1.42.634 1.42 1.416 0 .46-.222.868-.567 1.13z"/></svg>,
  },
];

const columnHeader = {
  fontFamily: fontMono,
  fontSize: 11,
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  fontWeight: 600,
  color: T.inkMutedOnDark,
  marginBottom: 16,
};

const linkStyle = {
  fontFamily: fontSans,
  fontSize: 14,
  color: T.inkMutedOnDark,
  fontWeight: 400,
  lineHeight: 1.6,
};

export default function Footer() {
  return (
    <footer
      style={{ background: T.ink, color: "#FFFFFF" }}
      className="px-6 md:px-10 pt-16 md:pt-20 pb-10"
      data-testid="global-footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 md:gap-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-2">
            <HaevnLogo className="h-6 w-auto mb-5" color="#FFFFFF" />
            <p
              style={{
                fontFamily: fontSans,
                fontSize: 14,
                lineHeight: 1.55,
                color: T.inkMutedOnDark,
                maxWidth: 320,
                fontWeight: 400,
              }}
            >
              Modern, technology-enabled matchmaking for adults who want the same thing.
            </p>
          </div>

          {/* Primary */}
          <div>
            <div style={columnHeader}>Product</div>
            <div className="space-y-3">
              {primary.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  style={linkStyle}
                  className="block hover:text-white transition-colors duration-200"
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <div style={columnHeader}>Company</div>
            <div className="space-y-3">
              {company.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  style={linkStyle}
                  className="block hover:text-white transition-colors duration-200"
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <div style={columnHeader}>Legal</div>
            <div className="space-y-3">
              {legal.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  style={linkStyle}
                  className="block hover:text-white transition-colors duration-200"
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom row — hairline divider, copyright + socials */}
        <div
          className="mt-14 md:mt-20 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
          style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}
        >
          <p
            style={{
              fontFamily: fontMono,
              fontSize: 11,
              letterSpacing: "0.08em",
              color: T.inkMutedOnDark,
              fontWeight: 500,
              textTransform: "uppercase",
            }}
          >
            © 2026 HAEVN · All rights reserved
          </p>
          <div className="flex items-center gap-5" data-testid="footer-socials">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors duration-200"
                style={{ color: T.inkMutedOnDark }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#FFFFFF")}
                onMouseLeave={(e) => (e.currentTarget.style.color = T.inkMutedOnDark)}
                data-testid={s.testid}
                aria-label={s.label}
              >
                {s.svg}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
